import React from 'react';
import { Card, Form, Input, Select, Row, Col, Space, Button } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { FormInstance } from 'antd/es/form';

const { Option } = Select;

interface AgeProps {
  form: FormInstance;
}

const Age: React.FC<AgeProps> = ({ form }) => {
  const yesNoOptions = ['Yes', 'No'];

  return (
    <Card title="Age" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Your DOB"
            name={['age_info', 'your_dob']}
          >
            <Input placeholder="MMDDYYYY" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Accused's DOB (if known)"
            name={['age_info', 'accused_dob']}
          >
            <Input placeholder="MMDDYYYY" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label="Is one or more of your coworkers younger than you?"
            name={['age_info', 'coworkers_younger']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Card type="inner" title="Other employees estimated age and DOB's (if known)">
        <Form.List name={['age_info', 'other_employees']}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                  <Form.Item
                    {...restField}
                    name={[name, 'age']}
                    label={`Age ${name + 1}:`}
                  >
                    <Input placeholder="Age" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'dob']}
                    label="DOB:"
                  >
                    <Input placeholder="MMDDYYYY" />
                  </Form.Item>
                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              <Form.Item>
                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                  Add Employee
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Card>
    </Card>
  );
};

export default Age;

